module.exports = __webpack_public_path__ + "img/tratamento_alflorex.f115498c.jpg";